import React, { useState, useContext } from "react";
import SearchField from "../SearchField/SearchField";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import SocketContext from "../../contexts/SocketContext";

import "./AddSupplierModal.css";

const AddSupplierModal = ({ show, setShow, reloaddata, setReloaddata }) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // New Supplier
  const [newsupplier, setNewsupplier] = useState();

  // Search field clean up
  const [toggleSFclear, setToggleSFclear] = useState(false);

  //clean up
  const cleanNewSupplier = () => {
    setNewsupplier({});
    setToggleSFclear(!toggleSFclear);
  };

  // handle input change
  const handleInputChange = (e) => {
    setNewsupplier({ ...newsupplier, [e.target.name]: e.target.value });
  };

  // handle country select
  const handleCountrySelect = (item) => {
    setNewsupplier({ ...newsupplier, ["countryID"]: item.countryID, ["country"]: item.country });
  };
  // handle port select
  const handlePortSelect = (item) => {
    setNewsupplier({ ...newsupplier, ["POLID"]: item.POLID, ["portOfLoad"]: item.portOfLoad });
  };

  // save new customer
  const saveNewSupplier = async () => {
    try {
      const response = await axiosPrivate.post("api/suppliers/addnewsupplier", {
        newsupplier,
      });
      if (response.data.msg === "Saved") {
        let newsuppliersocket = {
          ...newsupplier,
          ["supplierID"]: response.data.supplierID,
          ["region"]: response.data.region,
        };
        setShow(false);
        cleanNewSupplier();
        setReloaddata(!reloaddata);
        await socket.emit("newsupplier", newsuppliersocket);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  return (
    <div className={show ? "custommodal" : "custommodal hide"}>
      <div className='smodal-main'>
        <div className='as-header'>
          <h2>Add New Supplier:</h2>
          <p
            onClick={(e) => {
              setShow(false);
              cleanNewSupplier();
            }}
          >
            Close
          </p>
        </div>
        <form
          className='addnewsupplier'
          onSubmit={(e) => {
            e.preventDefault();
            saveNewSupplier();
          }}
        >
          <div className='form-item'>
            <label>Company Code:</label>
            <input
              required
              name='companyCode'
              // autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newsupplier?.companyCode || ""}
              autoComplete='none'
            />
          </div>
          <div className='form-item'>
            <label>Company Name:</label>
            <input
              required
              name='companyName'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newsupplier?.companyName || ""}
            />
          </div>
          <div className='form-item'>
            <label>Address:</label>
            <textarea
              required
              name='streetAddress'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newsupplier?.streetAddress || ""}
            />
          </div>
          <div className='form-item'>
            <label>City:</label>
            <input
              required
              name='city'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newsupplier?.city || ""}
            />
          </div>
          <div className='form-item'>
            <label>Country:</label>
            <SearchField
              required={true}
              searchURL='api/countries/getcountries'
              value={newsupplier?.country}
              valueName='country'
              valueID='countryID'
              style={{ width: "95%" }}
              onItemSelect={handleCountrySelect}
              clearfield={toggleSFclear}
              autoComplete='none'
            />
          </div>
          <div className='form-item'>
            <label>Default POD:</label>
            <SearchField
              required={true}
              searchURL='api/ports/getallloadports'
              value={newsupplier?.port}
              valueName='portOfLoad'
              valueID='POLID'
              style={{ width: "95%" }}
              onItemSelect={handlePortSelect}
              clearfield={toggleSFclear}
            />
          </div>
          <div className='form-item'>
            <label>Website:</label>
            <input
              required
              name='website'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newsupplier?.website || ""}
            />
          </div>
          <div className='form-item'>
            <label>Notes:</label>
            <textarea
              name='notes'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newsupplier?.notes || ""}
            />
          </div>
          <div className='form-buttons'>
            <button type='button' onClick={(e) => cleanNewSupplier()}>
              Clear
            </button>
            <button type='submit' className='mainbutton'>
              Save New
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSupplierModal;
